import { defineMessages } from 'react-intl';

export default defineMessages({
  completeOpening: {
    id: 'manager_page.complete_opening_claim',
  },
  client: {
    id: 'claims.client',
  },
  lossDate: {
    id: 'claims.loss_date',
  },
  openingDate: {
    id: 'claims.opening_date',
  },
  numberOfVictim: {
    id: 'claims.number_of_victim',
  },
  preOpeningDate: {
    id: 'claims.preopening_date',
  },
  title: {
    id: 'rejected_claims.manager.title',
  },
  lossHour: {
    id: 'claims.loss_hour',
  },
  claimPlace: {
    id: 'claims.claim_place',
  },
  registrationNumber: {
    id: 'claims.registration_number',
  },
  lawyer: {
    id: 'claims.lawyer',
  },
  linesPerPage: {
    id: 'lines_per_page',
  },
  managementMode: {
    id: 'manager_recap_validation_drawer.management_mode',
  },
  convertClaimTitle: {
    id: 'opening_manager.convert_claim.title',
  },
  uploadedDocuments: {
    id: 'manager_page.uploaded_documents',
  },
  changeNatureClaim: {
    id: 'opening_manager.convert_nature_claim.title',
  },
  changeNatureClaimQuestion: {
    id: 'opening_manager.convert_nature_claim.question',
  },
  yes: {
    id: 'preopening_page.claim_information.yes',
  },
  no: {
    id: 'preopening_page.claim_information.no',
  },
  reason: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_withdrawal_reason',
  },
  decisionSuccess: {
    id: 'expertise_expert.decision.toast_appreciation',
  },
  sideBarNotificationDialogTitle: {
    id: 'side_bar.notification.dialog.confirmation',
  },
  convertClaimConfirmationDescriptionReject: {
    id: 'opening_manager.convert_claim.confirmation.dialog.description_reject',
  },
  convertClaimConfirmationDescriptionAccept: {
    id: 'opening_manager.convert_claim.confirmation.dialog.description_accept',
  },
  convertClaimConfirmationValidationButton: {
    id:
      'opening_manager.convert_claim.confirmation.dialog.validation_button_title',
  },
  convertClaimConfirmationCancelButton: {
    id: 'opening_manager.convert_claim.confirmation.dialog.cancel_button_title',
  },
  convertClaimDialogInfo: {
    id: 'opening_manager.convert_claim.confirmation.dialog.info',
  },
  convertClaimSuccessToast: {
    id: 'opening_manager.convert_claim.success_toast.title',
  },
  preOpeningPageAlertError: {
    id: 'preopening_page.alert_error',
  },
});
